import React from 'react';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import Table from '../../../../components/tables/Table';
import tableStyles from '../../../../components/tables/Table.styles';

import { useNavWithTrail } from '../../../../layouts/TrailProvider';

const COLUMNS = [
  {
    label: 'EVN',
    field: 'evn',
    type: 'string',
    sortable: true,
    render: (_row, v, nav) => (
      <Typography
        sx={tableStyles.tableLink}
        onClick={() => nav(`/home/evns/${encodeURIComponent(String(v))}`)}
      >
        {v}
      </Typography>
    ),
  },
  {
    label: 'Unit',
    field: 'trainNumber',
    type: 'string', 
    sortable: true,
    render: (_row, v, nav) =>
      v ? (
        <Typography
          sx={tableStyles.tableLink}
          onClick={() => nav(`/home/units/${encodeURIComponent(String(v))}`)}
        >
          {v}
        </Typography>
      ) : (
        '—'
      ),
  },
  {
    label: 'Created On',
    field: 'createdOn',
    type: 'date',
    sortable: true, 
  },
];

export default function EVNTable({ rows = [] }) {
  const navigate = useNavigate();
  const nav = useNavWithTrail(navigate);

  const columnsWithNav = COLUMNS.map((c) =>
    c.render
      ? { ...c, render: (row, value) => c.render(row, value ?? row?.[c.field], nav) }
      : c
  );

  return (
    <Table
      rows={Array.isArray(rows) ? rows : []}
      columns={columnsWithNav}
      stickyHeader
      zebra
      hover
      bordered

    />
  );
}
